import { Button } from 'antd';
import React from 'react';
import { Tooltip } from 'antd';

interface FormActionButtonsProps {
  cancelText?: string;
  confirmText?: string;
  onCancel?: () => void;
  isConfirmDisabled?: boolean;
  isCancelDisabled?: boolean;
  includeCancel?: boolean;
  includeConfirm?: boolean;
  confirmOutlined?: boolean;
  onConfirm?: () => void;
  cancelColor?: 'danger' | 'default' | 'primary';
  confirmColor?: 'danger' | 'default' | 'primary';
  confirmTooltipTitle?: string;
  isFormSubmit?: boolean;
  containerClassName?: string;
}

const FormActionButtons: React.FC<FormActionButtonsProps> = ({
  cancelText = 'Cancel',
  confirmText = 'Confirm',
  onCancel,
  isConfirmDisabled,
  isCancelDisabled,
  includeCancel = true,
  includeConfirm = true,
  confirmOutlined = true,
  onConfirm,
  cancelColor = 'danger',
  confirmColor = 'primary',
  confirmTooltipTitle,
  isFormSubmit = true,
  containerClassName,
}) => {
  return (
    <div className={`flex flex-col sm:flex-row gap-2 ${containerClassName}`}>
      {!!includeCancel && (
        <Button
          className="w-full rounded-[12px] h-12 text-base font-medium"
          size="large"
          onClick={onCancel}
          type="primary"
          variant="outlined"
          color={cancelColor}
          disabled={isCancelDisabled}
        >
          {cancelText}
        </Button>
      )}
      {!!includeConfirm && (
        <Tooltip title={confirmTooltipTitle}>
          <Button
            className="w-full rounded-[12px] h-12 text-base font-medium"
            size="large"
            htmlType={isFormSubmit ? 'submit' : 'button'}
            danger={confirmColor === 'danger'}
            type="primary"
            variant={confirmOutlined ? 'outlined' : undefined}
            color={confirmColor}
            disabled={isConfirmDisabled}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </Tooltip>
      )}
    </div>
  );
};

export default FormActionButtons;
